export const WHAT_3_WORDS_ADDRESS_PATTERN = /^(\/{3})?.+\..+\..+$/;
export const USREOU_CODE_PATTERN = /^\d{7,8}$/;
